
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4cc0"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4cc0"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("giU2u", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $bde9cc018c642020$export$6503ec6e8aabbaf; }, function (v) { return $bde9cc018c642020$export$6503ec6e8aabbaf = v; });
var $bde9cc018c642020$export$6503ec6e8aabbaf;
var $bde9cc018c642020$export$f7ad0328861e2f03;
"use strict";
var $bde9cc018c642020$var$mapping = new Map();
function $bde9cc018c642020$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$bde9cc018c642020$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $bde9cc018c642020$var$resolve(id) {
    var resolved = $bde9cc018c642020$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$bde9cc018c642020$export$6503ec6e8aabbaf = $bde9cc018c642020$var$register;
$bde9cc018c642020$export$f7ad0328861e2f03 = $bde9cc018c642020$var$resolve;

});

var $0369f20c86dd566e$exports = {};

(parcelRequire("giU2u")).register(new URL("", import.meta.url).toString(), JSON.parse('["9pjuS","index.afcf2f32.js","4wVOL","telegram.b09f6b58.png","21N0M","instagram.5b393fa6.png","X7MwZ","close.07d159f0.png","98ngV","main1.fb2c2452.jpg","5l4EG","BS-1.b1c4096e.jpg","fOSuS","BS-2.6992feb1.jpg","8Pr4E","BS-3.77317860.jpg","fsovb","BS-4.a6829d22.jpg","2w6S1","main2.80e29f12.jpg","lSRJY","BF-1.448207ab.jpg","krpF3","BF-2.80d162a1.jpg","l7rIW","BF-3.b7a25b93.jpg","5BDCs","BF-4.8e7b04ce.jpg","3ijd4","BF-5.111f6a30.jpg","hvpIo","BF-6.3fe7dd5e.jpg","d5xhr","BF-7.ce150853.jpg","iO0qK","BF-8.cd11d0b2.jpg","1A9li","BF-9.5190af88.jpg","hebCO","BF-10.52568166.jpg","34ouQ","BF-11.71b1eb4b.jpg","6eunJ","BF-12.dc43d1d6.jpg","g6l6w","BF-13.457883ba.jpg","cUscG","BF-14.b6cafb46.jpg","jHlhp","BF-15.a039d926.jpg","Ejd3u","BF-16.c5afc476.jpg","fpnaB","BF-17.73953c15.jpg","aPA3I","BF-18.2dad4280.jpg","2D4gA","BF-19.e0b29269.jpg","cynO4","BF-20.32eabb0e.jpg","f1pWN","BF-21.d790adcd.jpg","rgDzD","BF-22.1866c74e.jpg","5xVem","BF-23.860bec8d.jpg","764Et","main3.50729b7c.jpg","7l0Ac","RES-1.a644e060.jpg","49iii","RES-2.afbb8be2.jpg","lcBeL","RES-3.d631ce38.jpg","aoLff","RES-4.4d3cb7c9.jpg","7b6XT","RES-5.e25b624f.jpg","cC7vz","RES-6.7b516782.jpg","2IPaR","RES-7.1fc756bd.jpg","5AI15","RES-8.fdec353c.jpg","e6iSM","RES-9.c9b95569.jpg","iMCLo","RES-10.33e14cc8.jpg","45gaO","RES-11.d2686d7a.jpg","hyuGl","RES-12.cfcbf728.jpg","3mxRR","RES-13.091f32e9.jpg","hZLwm","RES-14.465bf51f.jpg","2eK5v","RES-15.6a66e989.jpg","4Eo60","RES-16.7d0b58dd.jpg","ZRkbF","RES-17.418e28c0.jpg","awTZf","RES-18.879f0800.jpg","j7pK5","main4.985b13a4.jpg","fPpIh","A-1.3c4f5dc8.jpg","1CQBx","A-2.68076ffa.jpg","ebtuB","A-3.6fc4dfb4.jpg","c0gX4","A-4.50608e25.jpg","8Fknt","A-5.faf5ed7d.jpg","754fr","A-6.aa1fc8df.jpg","fpBuN","A-7.1cf08efc.jpg","bFE0T","A-8.54cdbd59.jpg","lqZtO","A-9.11efdda6.jpg","jQ3Xx","A-10.31bc9b47.jpg","2wZgG","A-11.de4c2bf5.jpg","g19sO","A-12.d1b895d0.jpg","7OZgD","A-13.0f9a0f4e.jpg","2Inao","A-14.c735f2ea.jpg","amiE9","A-15.ed03dde4.jpg","3qvWY","A-16.ce344de6.jpg","82Xdx","A-17.66a5aab1.jpg","cImZ4","A-18.3f0e546d.jpg","bWnEJ","A-19.b1658cff.jpg","hjmYo","A-20.330d7a8e.jpg","kOxSx","A-21.fb95b79d.jpg","aXcty","A-22.28dec37d.jpg","jpcdR","A-23.c9ac5281.jpg","kdVsP","A-24.5015477c.jpg","h9uig","A-25.afde6513.jpg","dpOEy","A-26.0f2f514f.jpg","bsQ2r","A-27.b240293e.jpg","iO7RF","A-28.f10e055d.jpg","5TMqL","A-29.68dc3b24.jpg","8q6XO","A-30.17fb5198.jpg","aW0wG","A-31.776d99a3.jpg","h3hzb","main5.d567883b.jpg","d6otH","CH-1.c1211edd.jpg","f5I89","CH-2.5cc1add4.jpg","cLNQn","CH-3.ec597a9a.jpg","1xl1y","CH-4.54acfa33.jpg","6GqqV","CH-5.27679d1d.jpg","kjN4s","CH-6.3b34f07a.jpg","iQCo9","CH-7.acc99de0.jpg","cZwPk","CH-8.77b418c2.jpg","fh7a5","CH-9.d257b5e0.jpg","cIqMA","CH-10.1b572ba5.jpg","cWtfN","CH-11.f3db64bb.jpg","l3F5E","CH-12.b12b2b20.jpg","dJ5Yo","CH-13.21a8a0d3.jpg","bxtml","CH-14.d85feca2.jpg","7Umb2","CH-15.0d50e49c.jpg","1JeBU","CH-16.f943b286.jpg"]'));

var $a9ee903bc78d0bca$exports = {};
$a9ee903bc78d0bca$exports = new URL("telegram.b09f6b58.png", import.meta.url).toString();


var $90142b55ec8dfea3$exports = {};
$90142b55ec8dfea3$exports = new URL("instagram.5b393fa6.png", import.meta.url).toString();


var $1714814868cb76f0$exports = {};
$1714814868cb76f0$exports = new URL("close.07d159f0.png", import.meta.url).toString();


var $f7229e48954648a2$exports = {};
$f7229e48954648a2$exports = new URL("main1.fb2c2452.jpg", import.meta.url).toString();


var $3989b8dc575fe235$exports = {};
$3989b8dc575fe235$exports = new URL("BS-1.b1c4096e.jpg", import.meta.url).toString();


var $12bfac57699f09fc$exports = {};
$12bfac57699f09fc$exports = new URL("BS-2.6992feb1.jpg", import.meta.url).toString();


var $85c08d67ef9e42b4$exports = {};
$85c08d67ef9e42b4$exports = new URL("BS-3.77317860.jpg", import.meta.url).toString();


var $7dd75b00d34f12ec$exports = {};
$7dd75b00d34f12ec$exports = new URL("BS-4.a6829d22.jpg", import.meta.url).toString();


var $35c8ea11fefe0691$exports = {};
$35c8ea11fefe0691$exports = new URL("main2.80e29f12.jpg", import.meta.url).toString();


var $5efd15fabe3dd611$exports = {};
$5efd15fabe3dd611$exports = new URL("BF-1.448207ab.jpg", import.meta.url).toString();


var $c4c9b5272d64866b$exports = {};
$c4c9b5272d64866b$exports = new URL("BF-2.80d162a1.jpg", import.meta.url).toString();


var $d188b6d8c1587b42$exports = {};
$d188b6d8c1587b42$exports = new URL("BF-3.b7a25b93.jpg", import.meta.url).toString();


var $c165f3e706d0ba4d$exports = {};
$c165f3e706d0ba4d$exports = new URL("BF-4.8e7b04ce.jpg", import.meta.url).toString();


var $6692170f0c59dcc1$exports = {};
$6692170f0c59dcc1$exports = new URL("BF-5.111f6a30.jpg", import.meta.url).toString();


var $2a99b15883dfdaac$exports = {};
$2a99b15883dfdaac$exports = new URL("BF-6.3fe7dd5e.jpg", import.meta.url).toString();


var $a6ca26e493ee0a7a$exports = {};
$a6ca26e493ee0a7a$exports = new URL("BF-7.ce150853.jpg", import.meta.url).toString();


var $da8d090a0fb7ba58$exports = {};
$da8d090a0fb7ba58$exports = new URL("BF-8.cd11d0b2.jpg", import.meta.url).toString();


var $5f0baa44caff14f1$exports = {};
$5f0baa44caff14f1$exports = new URL("BF-9.5190af88.jpg", import.meta.url).toString();


var $c2264975b50c869d$exports = {};
$c2264975b50c869d$exports = new URL("BF-10.52568166.jpg", import.meta.url).toString();


var $d0a601c2f8760ba5$exports = {};
$d0a601c2f8760ba5$exports = new URL("BF-11.71b1eb4b.jpg", import.meta.url).toString();


var $c1d3a4aefd1fa088$exports = {};
$c1d3a4aefd1fa088$exports = new URL("BF-12.dc43d1d6.jpg", import.meta.url).toString();


var $6016a358a8c20e0f$exports = {};
$6016a358a8c20e0f$exports = new URL("BF-13.457883ba.jpg", import.meta.url).toString();


var $c2831d821419d254$exports = {};
$c2831d821419d254$exports = new URL("BF-14.b6cafb46.jpg", import.meta.url).toString();


var $e12d0f38b86c46d6$exports = {};
$e12d0f38b86c46d6$exports = new URL("BF-15.a039d926.jpg", import.meta.url).toString();


var $8796012b20427fcc$exports = {};
$8796012b20427fcc$exports = new URL("BF-16.c5afc476.jpg", import.meta.url).toString();


var $5a4437c8079896d6$exports = {};
$5a4437c8079896d6$exports = new URL("BF-17.73953c15.jpg", import.meta.url).toString();


var $1d4a7ab5c3667b81$exports = {};
$1d4a7ab5c3667b81$exports = new URL("BF-18.2dad4280.jpg", import.meta.url).toString();


var $eb5677b4b13293fc$exports = {};
$eb5677b4b13293fc$exports = new URL("BF-19.e0b29269.jpg", import.meta.url).toString();


var $c611d5dc3f58016a$exports = {};
$c611d5dc3f58016a$exports = new URL("BF-20.32eabb0e.jpg", import.meta.url).toString();


var $1dc136203f28346d$exports = {};
$1dc136203f28346d$exports = new URL("BF-21.d790adcd.jpg", import.meta.url).toString();


var $dc5adc00af846479$exports = {};
$dc5adc00af846479$exports = new URL("BF-22.1866c74e.jpg", import.meta.url).toString();


var $57cf15c0dffa605e$exports = {};
$57cf15c0dffa605e$exports = new URL("BF-23.860bec8d.jpg", import.meta.url).toString();


var $ab521aa6ce4843d1$exports = {};
$ab521aa6ce4843d1$exports = new URL("main3.50729b7c.jpg", import.meta.url).toString();


var $22353d873cadce33$exports = {};
$22353d873cadce33$exports = new URL("RES-1.a644e060.jpg", import.meta.url).toString();


var $c28107bfc47521ba$exports = {};
$c28107bfc47521ba$exports = new URL("RES-2.afbb8be2.jpg", import.meta.url).toString();


var $8fe7819c56ee6f02$exports = {};
$8fe7819c56ee6f02$exports = new URL("RES-3.d631ce38.jpg", import.meta.url).toString();


var $1e7fa891e9673dab$exports = {};
$1e7fa891e9673dab$exports = new URL("RES-4.4d3cb7c9.jpg", import.meta.url).toString();


var $935f7751ffc71931$exports = {};
$935f7751ffc71931$exports = new URL("RES-5.e25b624f.jpg", import.meta.url).toString();


var $0149b10a07359f87$exports = {};
$0149b10a07359f87$exports = new URL("RES-6.7b516782.jpg", import.meta.url).toString();


var $67814c1d808bacca$exports = {};
$67814c1d808bacca$exports = new URL("RES-7.1fc756bd.jpg", import.meta.url).toString();


var $27afd440bc667f1b$exports = {};
$27afd440bc667f1b$exports = new URL("RES-8.fdec353c.jpg", import.meta.url).toString();


var $5e131f96058c7ab3$exports = {};
$5e131f96058c7ab3$exports = new URL("RES-9.c9b95569.jpg", import.meta.url).toString();


var $41a6d44ddabfbe4f$exports = {};
$41a6d44ddabfbe4f$exports = new URL("RES-10.33e14cc8.jpg", import.meta.url).toString();


var $01dcfd946dee4cef$exports = {};
$01dcfd946dee4cef$exports = new URL("RES-11.d2686d7a.jpg", import.meta.url).toString();


var $481d93a7af2e9bb8$exports = {};
$481d93a7af2e9bb8$exports = new URL("RES-12.cfcbf728.jpg", import.meta.url).toString();


var $0632de2e474ca770$exports = {};
$0632de2e474ca770$exports = new URL("RES-13.091f32e9.jpg", import.meta.url).toString();


var $0e384db6ad1bf684$exports = {};
$0e384db6ad1bf684$exports = new URL("RES-14.465bf51f.jpg", import.meta.url).toString();


var $42feae935540a21c$exports = {};
$42feae935540a21c$exports = new URL("RES-15.6a66e989.jpg", import.meta.url).toString();


var $22b1b014a89e30c2$exports = {};
$22b1b014a89e30c2$exports = new URL("RES-16.7d0b58dd.jpg", import.meta.url).toString();


var $660a5125a5683413$exports = {};
$660a5125a5683413$exports = new URL("RES-17.418e28c0.jpg", import.meta.url).toString();


var $9c5e841054b65117$exports = {};
$9c5e841054b65117$exports = new URL("RES-18.879f0800.jpg", import.meta.url).toString();


var $ece0b4dc5289869e$exports = {};
$ece0b4dc5289869e$exports = new URL("main4.985b13a4.jpg", import.meta.url).toString();


var $e256a0fe74ae6c0e$exports = {};
$e256a0fe74ae6c0e$exports = new URL("A-1.3c4f5dc8.jpg", import.meta.url).toString();


var $64670af7d6091a5d$exports = {};
$64670af7d6091a5d$exports = new URL("A-2.68076ffa.jpg", import.meta.url).toString();


var $e2e83ff5d4ec0bc4$exports = {};
$e2e83ff5d4ec0bc4$exports = new URL("A-3.6fc4dfb4.jpg", import.meta.url).toString();


var $f8c38f54e6e89d68$exports = {};
$f8c38f54e6e89d68$exports = new URL("A-4.50608e25.jpg", import.meta.url).toString();


var $3f7f36f4a2c10808$exports = {};
$3f7f36f4a2c10808$exports = new URL("A-5.faf5ed7d.jpg", import.meta.url).toString();


var $a5167afadfb25b66$exports = {};
$a5167afadfb25b66$exports = new URL("A-6.aa1fc8df.jpg", import.meta.url).toString();


var $9c0f4ff9e701d06e$exports = {};
$9c0f4ff9e701d06e$exports = new URL("A-7.1cf08efc.jpg", import.meta.url).toString();


var $a0c487e917095b36$exports = {};
$a0c487e917095b36$exports = new URL("A-8.54cdbd59.jpg", import.meta.url).toString();


var $9bf9fbf839f47cd1$exports = {};
$9bf9fbf839f47cd1$exports = new URL("A-9.11efdda6.jpg", import.meta.url).toString();


var $2b89691366ec838c$exports = {};
$2b89691366ec838c$exports = new URL("A-10.31bc9b47.jpg", import.meta.url).toString();


var $93e5f760c5bd2884$exports = {};
$93e5f760c5bd2884$exports = new URL("A-11.de4c2bf5.jpg", import.meta.url).toString();


var $ba6a252f9804ba58$exports = {};
$ba6a252f9804ba58$exports = new URL("A-12.d1b895d0.jpg", import.meta.url).toString();


var $167c6058756ae656$exports = {};
$167c6058756ae656$exports = new URL("A-13.0f9a0f4e.jpg", import.meta.url).toString();


var $8a5d6f4883823860$exports = {};
$8a5d6f4883823860$exports = new URL("A-14.c735f2ea.jpg", import.meta.url).toString();


var $5a426e026dbab63c$exports = {};
$5a426e026dbab63c$exports = new URL("A-15.ed03dde4.jpg", import.meta.url).toString();


var $743b8daf025e0e58$exports = {};
$743b8daf025e0e58$exports = new URL("A-16.ce344de6.jpg", import.meta.url).toString();


var $f8d52edb6fc27d1a$exports = {};
$f8d52edb6fc27d1a$exports = new URL("A-17.66a5aab1.jpg", import.meta.url).toString();


var $bb45fca6135a6c52$exports = {};
$bb45fca6135a6c52$exports = new URL("A-18.3f0e546d.jpg", import.meta.url).toString();


var $814eb5ce23555c3f$exports = {};
$814eb5ce23555c3f$exports = new URL("A-19.b1658cff.jpg", import.meta.url).toString();


var $95f91e1e19074feb$exports = {};
$95f91e1e19074feb$exports = new URL("A-20.330d7a8e.jpg", import.meta.url).toString();


var $4f76d8278ba73ca2$exports = {};
$4f76d8278ba73ca2$exports = new URL("A-21.fb95b79d.jpg", import.meta.url).toString();


var $be99e67a646519c0$exports = {};
$be99e67a646519c0$exports = new URL("A-22.28dec37d.jpg", import.meta.url).toString();


var $5dfd7d50b5c2c031$exports = {};
$5dfd7d50b5c2c031$exports = new URL("A-23.c9ac5281.jpg", import.meta.url).toString();


var $8942787277361d40$exports = {};
$8942787277361d40$exports = new URL("A-24.5015477c.jpg", import.meta.url).toString();


var $aee95e261082ea78$exports = {};
$aee95e261082ea78$exports = new URL("A-25.afde6513.jpg", import.meta.url).toString();


var $988623847232677f$exports = {};
$988623847232677f$exports = new URL("A-26.0f2f514f.jpg", import.meta.url).toString();


var $236b395ecb890337$exports = {};
$236b395ecb890337$exports = new URL("A-27.b240293e.jpg", import.meta.url).toString();


var $e74e1de0e028804d$exports = {};
$e74e1de0e028804d$exports = new URL("A-28.f10e055d.jpg", import.meta.url).toString();


var $99eb3f94d11cfd2c$exports = {};
$99eb3f94d11cfd2c$exports = new URL("A-29.68dc3b24.jpg", import.meta.url).toString();


var $1a5e8485c7f925ce$exports = {};
$1a5e8485c7f925ce$exports = new URL("A-30.17fb5198.jpg", import.meta.url).toString();


var $339040ea57bb58a7$exports = {};
$339040ea57bb58a7$exports = new URL("A-31.776d99a3.jpg", import.meta.url).toString();


var $9a8799fc845dc58e$exports = {};
$9a8799fc845dc58e$exports = new URL("main5.d567883b.jpg", import.meta.url).toString();


var $fa5a0347dea147da$exports = {};
$fa5a0347dea147da$exports = new URL("CH-1.c1211edd.jpg", import.meta.url).toString();


var $0997f82a9ddf27cf$exports = {};
$0997f82a9ddf27cf$exports = new URL("CH-2.5cc1add4.jpg", import.meta.url).toString();


var $4e2859bea17915a3$exports = {};
$4e2859bea17915a3$exports = new URL("CH-3.ec597a9a.jpg", import.meta.url).toString();


var $9d71eddeeb55bb1f$exports = {};
$9d71eddeeb55bb1f$exports = new URL("CH-4.54acfa33.jpg", import.meta.url).toString();


var $07e8d8991bf446d0$exports = {};
$07e8d8991bf446d0$exports = new URL("CH-5.27679d1d.jpg", import.meta.url).toString();


var $75aab771a1ff6795$exports = {};
$75aab771a1ff6795$exports = new URL("CH-6.3b34f07a.jpg", import.meta.url).toString();


var $baf3c69a8c8b4f49$exports = {};
$baf3c69a8c8b4f49$exports = new URL("CH-7.acc99de0.jpg", import.meta.url).toString();


var $136a7971b8762c22$exports = {};
$136a7971b8762c22$exports = new URL("CH-8.77b418c2.jpg", import.meta.url).toString();


var $27e68ee3d559cb40$exports = {};
$27e68ee3d559cb40$exports = new URL("CH-9.d257b5e0.jpg", import.meta.url).toString();


var $9c047c756214629e$exports = {};
$9c047c756214629e$exports = new URL("CH-10.1b572ba5.jpg", import.meta.url).toString();


var $8481950dfc0be19d$exports = {};
$8481950dfc0be19d$exports = new URL("CH-11.f3db64bb.jpg", import.meta.url).toString();


var $dda6acf3f53f5b33$exports = {};
$dda6acf3f53f5b33$exports = new URL("CH-12.b12b2b20.jpg", import.meta.url).toString();


var $38a246f056627768$exports = {};
$38a246f056627768$exports = new URL("CH-13.21a8a0d3.jpg", import.meta.url).toString();


var $5c9e276c5bb04d95$exports = {};
$5c9e276c5bb04d95$exports = new URL("CH-14.d85feca2.jpg", import.meta.url).toString();


var $69adf5dbcefa21d1$exports = {};
$69adf5dbcefa21d1$exports = new URL("CH-15.0d50e49c.jpg", import.meta.url).toString();


var $786a5c2a45ce367b$exports = {};
$786a5c2a45ce367b$exports = new URL("CH-16.f943b286.jpg", import.meta.url).toString();


"use strict";
document.addEventListener("DOMContentLoaded", function() {
    const images = document.querySelectorAll(".header-image");
    let currentImageIndex = 0;
    function changeImageVisibility() {
        images.forEach((image, index)=>{
            image.style.opacity = index === currentImageIndex ? 1 : 0;
        });
        currentImageIndex = (currentImageIndex + 1) % images.length;
    }
    setInterval(changeImageVisibility, 3000);
});
document.getElementById("myForm").addEventListener("submit", async function(event) {
    event.preventDefault();
    const name = document.getElementById("name").value;
    const message = document.getElementById("message").value;
    const phone = document.getElementById("phone").value;
    const sendButton = document.getElementById("send-button");
    const sendButtonWrapper = document.getElementById("send-button-wrapper");
    sendButtonWrapper.style.cursor = "wait";
    sendButton.style.pointerEvents = "none";
    try {
        const response = await fetch("https://send-data-to-telegram.onrender.com/submit-form", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                name: name,
                message: message,
                phone: phone
            })
        });
        if (!response.ok) throw new Error("\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u0440\u0438 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u0456 \u0434\u0430\u043D\u0438\u0445 \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440");
        alert("\u0417\u0430\u044F\u0432\u043A\u0430 \u0443\u0441\u043F\u0456\u0448\u043D\u043E \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0430! \u041E\u0447\u0456\u043A\u0443\u0439\u0442\u0435, \u0431\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u043D\u0430 \u0432\u0456\u0434\u043F\u043E\u0432\u0456\u0434\u044C \u0443 telegram!");
        this.reset();
    } catch (error) {
        console.error("\u0421\u0442\u0430\u043B\u0430\u0441\u044F \u043F\u043E\u043C\u0438\u043B\u043A\u0430:", error);
        alert("\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u0440\u0438 \u0432\u0456\u0434\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u0456 \u0434\u0430\u043D\u0438\u0445");
    } finally{
        sendButtonWrapper.style.cursor = "pointer";
        sendButton.style.pointerEvents = "all";
    }
});
let $67531365a2ce8fb7$var$button;
let $67531365a2ce8fb7$var$buttonImage;
let $67531365a2ce8fb7$var$socialIcons;
let $67531365a2ce8fb7$var$animationInterval = null;
let $67531365a2ce8fb7$var$currentIndex = 0;
const $67531365a2ce8fb7$var$images = [
    (0, (/*@__PURE__*/$parcel$interopDefault($a9ee903bc78d0bca$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($90142b55ec8dfea3$exports))),
    (0, (/*@__PURE__*/$parcel$interopDefault($1714814868cb76f0$exports)))
];
function $67531365a2ce8fb7$var$startAnimation() {
    $67531365a2ce8fb7$var$buttonImage.style.width = "40px";
    $67531365a2ce8fb7$var$buttonImage.style.height = "40px";
    if ($67531365a2ce8fb7$var$animationInterval === null) $67531365a2ce8fb7$var$animationInterval = setInterval(function() {
        $67531365a2ce8fb7$var$currentIndex = ($67531365a2ce8fb7$var$currentIndex + 1) % ($67531365a2ce8fb7$var$images.length - 1);
        $67531365a2ce8fb7$var$buttonImage.classList.add("scale-out");
        setTimeout(()=>{
            $67531365a2ce8fb7$var$buttonImage.src = $67531365a2ce8fb7$var$images[$67531365a2ce8fb7$var$currentIndex];
            $67531365a2ce8fb7$var$buttonImage.classList.remove("scale-out");
        }, 500);
    }, 1500);
}
function $67531365a2ce8fb7$var$stopAnimation() {
    clearInterval($67531365a2ce8fb7$var$animationInterval);
    $67531365a2ce8fb7$var$animationInterval = null;
}
document.addEventListener("DOMContentLoaded", function() {
    $67531365a2ce8fb7$var$button = document.querySelector("#social-button");
    $67531365a2ce8fb7$var$buttonImage = document.getElementById("buttonImage");
    $67531365a2ce8fb7$var$socialIcons = document.querySelector(".social-icons");
    $67531365a2ce8fb7$var$socialIcons.style.display = "none";
    $67531365a2ce8fb7$var$startAnimation();
    $67531365a2ce8fb7$var$button.addEventListener("click", function() {
        if ($67531365a2ce8fb7$var$currentIndex === $67531365a2ce8fb7$var$images.length - 1) {
            $67531365a2ce8fb7$var$buttonImage.src = $67531365a2ce8fb7$var$images[0];
            $67531365a2ce8fb7$var$socialIcons.style.display = "none";
            $67531365a2ce8fb7$var$socialIcons.classList.remove("show-icons");
            $67531365a2ce8fb7$var$startAnimation();
            $67531365a2ce8fb7$var$currentIndex = 0;
        } else {
            $67531365a2ce8fb7$var$buttonImage.src = $67531365a2ce8fb7$var$images[$67531365a2ce8fb7$var$images.length - 1];
            $67531365a2ce8fb7$var$socialIcons.style.display = "flex";
            $67531365a2ce8fb7$var$socialIcons.classList.add("show-icons");
            $67531365a2ce8fb7$var$stopAnimation();
            $67531365a2ce8fb7$var$currentIndex = $67531365a2ce8fb7$var$images.length - 1;
            $67531365a2ce8fb7$var$buttonImage.style.width = "20px";
            $67531365a2ce8fb7$var$buttonImage.style.height = "20px";
        }
    });
});
document.addEventListener("click", function(event) {
    const isClickInsideButton = $67531365a2ce8fb7$var$button.contains(event.target);
    const isClickInsideSocialIcons = $67531365a2ce8fb7$var$socialIcons.contains(event.target);
    if (!isClickInsideButton && !isClickInsideSocialIcons) {
        $67531365a2ce8fb7$var$socialIcons.style.display = "none";
        $67531365a2ce8fb7$var$socialIcons.classList.remove("show-icons");
        $67531365a2ce8fb7$var$buttonImage.src = $67531365a2ce8fb7$var$images[0];
        $67531365a2ce8fb7$var$startAnimation();
        $67531365a2ce8fb7$var$currentIndex = 0;
    }
});
document.addEventListener("DOMContentLoaded", function() {
    const animateOnVisibleElements = document.querySelectorAll(".animate-on-visible");
    animateOnVisibleElements.forEach(function(element) {
        if ($67531365a2ce8fb7$var$isElementInViewport(element)) setTimeout(function() {
            element.classList.add("visible");
        }, 500);
    });
    window.addEventListener("scroll", function() {
        animateOnVisibleElements.forEach(function(element) {
            if ($67531365a2ce8fb7$var$isElementInViewport(element)) element.classList.add("visible");
        });
    });
});
function $67531365a2ce8fb7$var$isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
}
let $67531365a2ce8fb7$var$slideIndex = 0;
const $67531365a2ce8fb7$var$slides = document.getElementsByClassName("slides");
function $67531365a2ce8fb7$var$showImage(n) {
    let i;
    const dots = document.getElementsByClassName("dots");
    if (n >= $67531365a2ce8fb7$var$slides.length) $67531365a2ce8fb7$var$slideIndex = 0;
    if (n < 0) $67531365a2ce8fb7$var$slideIndex = $67531365a2ce8fb7$var$slides.length - 1;
    for(i = 0; i < $67531365a2ce8fb7$var$slides.length; i++)$67531365a2ce8fb7$var$slides[i].style.display = "none";
    $67531365a2ce8fb7$var$slides[$67531365a2ce8fb7$var$slideIndex].style.display = "block";
    const images = JSON.parse($67531365a2ce8fb7$var$slides[$67531365a2ce8fb7$var$slideIndex].getAttribute("data-images"));
}
$67531365a2ce8fb7$var$showImage($67531365a2ce8fb7$var$slideIndex);
const $67531365a2ce8fb7$var$prevButton = document.querySelector(".prev");
const $67531365a2ce8fb7$var$nextButton = document.querySelector(".next");
let $67531365a2ce8fb7$var$autoSlideInterval;
$67531365a2ce8fb7$var$prevButton.addEventListener("click", function() {
    $67531365a2ce8fb7$var$plusIndex(-1);
    $67531365a2ce8fb7$var$resetAutoSlide();
});
$67531365a2ce8fb7$var$nextButton.addEventListener("click", function() {
    $67531365a2ce8fb7$var$plusIndex(1);
    $67531365a2ce8fb7$var$resetAutoSlide();
});
$67531365a2ce8fb7$var$autoSlideInterval = setInterval(function() {
    $67531365a2ce8fb7$var$plusIndex(1);
}, 5500);
function $67531365a2ce8fb7$var$resetAutoSlide() {
    clearInterval($67531365a2ce8fb7$var$autoSlideInterval);
    $67531365a2ce8fb7$var$autoSlideInterval = setInterval(function() {
        $67531365a2ce8fb7$var$plusIndex(1);
    }, 5500);
}
function $67531365a2ce8fb7$var$plusIndex(n) {
    $67531365a2ce8fb7$var$showImage($67531365a2ce8fb7$var$slideIndex += n);
}
function $67531365a2ce8fb7$var$startAutoSlide() {
    $67531365a2ce8fb7$var$autoSlideInterval = setInterval(function() {
        $67531365a2ce8fb7$var$plusIndex(1);
    }, 5500);
}
function $67531365a2ce8fb7$var$pauseAutoSlide() {
    clearInterval($67531365a2ce8fb7$var$autoSlideInterval);
}
const $67531365a2ce8fb7$var$hamburger = document.querySelector(".hamburger");
const $67531365a2ce8fb7$var$navLinks = document.querySelector(".nav-links");
const $67531365a2ce8fb7$var$links = document.querySelectorAll(".nav-links li");
let $67531365a2ce8fb7$var$currIndex = 0;
const $67531365a2ce8fb7$var$current = document.querySelector("#current");
let $67531365a2ce8fb7$var$imgs = document.querySelectorAll(".sub-imgs img");
const $67531365a2ce8fb7$var$img_opacity = 0.6;
document.querySelector(".sub-imgs").addEventListener("click", $67531365a2ce8fb7$var$imgClick);
function $67531365a2ce8fb7$var$imgClick(e) {
    $67531365a2ce8fb7$var$imgs.forEach((img)=>img.style.opacity = 1);
    $67531365a2ce8fb7$var$changeImageTo(e.target);
}
function $67531365a2ce8fb7$var$changeImageTo(image) {
    $67531365a2ce8fb7$var$imgs.forEach((img)=>img.style.opacity = 1);
    if (image.tagName === "IMG") {
        $67531365a2ce8fb7$var$current.src = image.src;
        $67531365a2ce8fb7$var$current.classList.add("fade-in");
        setTimeout(()=>$67531365a2ce8fb7$var$current.classList.remove("fade-in"), 500);
        image.style.opacity = $67531365a2ce8fb7$var$img_opacity;
    }
}
const $67531365a2ce8fb7$var$leftButton = document.getElementById("left-button");
const $67531365a2ce8fb7$var$rightButton = document.getElementById("right-button");
$67531365a2ce8fb7$var$leftButton.addEventListener("click", $67531365a2ce8fb7$var$leftScroll);
$67531365a2ce8fb7$var$rightButton.addEventListener("click", $67531365a2ce8fb7$var$rightScroll);
function $67531365a2ce8fb7$var$leftScroll() {
    for(let i = 0; i < $67531365a2ce8fb7$var$imgs.length; i++)if ($67531365a2ce8fb7$var$imgs[i].src === $67531365a2ce8fb7$var$current.src) {
        $67531365a2ce8fb7$var$currIndex = i - 1;
        if ($67531365a2ce8fb7$var$currIndex < 0) $67531365a2ce8fb7$var$currIndex += $67531365a2ce8fb7$var$imgs.length;
        $67531365a2ce8fb7$var$changeImageTo($67531365a2ce8fb7$var$imgs[$67531365a2ce8fb7$var$currIndex]);
        break;
    }
}
function $67531365a2ce8fb7$var$rightScroll() {
    for(let i = 0; i < $67531365a2ce8fb7$var$imgs.length; i++)if ($67531365a2ce8fb7$var$imgs[i].src === $67531365a2ce8fb7$var$current.src) {
        $67531365a2ce8fb7$var$currIndex = i + 1;
        if ($67531365a2ce8fb7$var$currIndex > $67531365a2ce8fb7$var$imgs.length - 1) $67531365a2ce8fb7$var$currIndex -= $67531365a2ce8fb7$var$imgs.length;
        $67531365a2ce8fb7$var$changeImageTo($67531365a2ce8fb7$var$imgs[$67531365a2ce8fb7$var$currIndex]);
        break;
    }
}
const $67531365a2ce8fb7$var$sliderContainer = document.getElementById("slider-container");
const $67531365a2ce8fb7$var$imagesForButtons = {
    button1: [
        (0, (/*@__PURE__*/$parcel$interopDefault($f7229e48954648a2$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($3989b8dc575fe235$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($12bfac57699f09fc$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($85c08d67ef9e42b4$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($7dd75b00d34f12ec$exports)))
    ],
    button2: [
        (0, (/*@__PURE__*/$parcel$interopDefault($35c8ea11fefe0691$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($5efd15fabe3dd611$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($c4c9b5272d64866b$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($d188b6d8c1587b42$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($c165f3e706d0ba4d$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($6692170f0c59dcc1$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($2a99b15883dfdaac$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($a6ca26e493ee0a7a$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($da8d090a0fb7ba58$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($5f0baa44caff14f1$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($c2264975b50c869d$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($d0a601c2f8760ba5$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($c1d3a4aefd1fa088$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($6016a358a8c20e0f$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($c2831d821419d254$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($e12d0f38b86c46d6$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($8796012b20427fcc$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($5a4437c8079896d6$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($1d4a7ab5c3667b81$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($eb5677b4b13293fc$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($c611d5dc3f58016a$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($1dc136203f28346d$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($dc5adc00af846479$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($57cf15c0dffa605e$exports)))
    ],
    button3: [
        (0, (/*@__PURE__*/$parcel$interopDefault($ab521aa6ce4843d1$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($22353d873cadce33$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($c28107bfc47521ba$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($8fe7819c56ee6f02$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($1e7fa891e9673dab$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($935f7751ffc71931$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($0149b10a07359f87$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($67814c1d808bacca$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($27afd440bc667f1b$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($5e131f96058c7ab3$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($41a6d44ddabfbe4f$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($01dcfd946dee4cef$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($481d93a7af2e9bb8$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($0632de2e474ca770$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($0e384db6ad1bf684$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($42feae935540a21c$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($22b1b014a89e30c2$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($660a5125a5683413$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($9c5e841054b65117$exports)))
    ],
    button4: [
        (0, (/*@__PURE__*/$parcel$interopDefault($ece0b4dc5289869e$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($e256a0fe74ae6c0e$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($64670af7d6091a5d$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($e2e83ff5d4ec0bc4$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($f8c38f54e6e89d68$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($3f7f36f4a2c10808$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($a5167afadfb25b66$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($9c0f4ff9e701d06e$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($a0c487e917095b36$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($9bf9fbf839f47cd1$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($2b89691366ec838c$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($93e5f760c5bd2884$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($ba6a252f9804ba58$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($167c6058756ae656$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($8a5d6f4883823860$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($5a426e026dbab63c$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($743b8daf025e0e58$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($f8d52edb6fc27d1a$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($bb45fca6135a6c52$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($814eb5ce23555c3f$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($95f91e1e19074feb$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($4f76d8278ba73ca2$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($be99e67a646519c0$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($5dfd7d50b5c2c031$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($8942787277361d40$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($aee95e261082ea78$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($988623847232677f$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($236b395ecb890337$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($e74e1de0e028804d$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($99eb3f94d11cfd2c$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($1a5e8485c7f925ce$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($339040ea57bb58a7$exports)))
    ],
    button5: [
        (0, (/*@__PURE__*/$parcel$interopDefault($9a8799fc845dc58e$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($fa5a0347dea147da$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($0997f82a9ddf27cf$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($4e2859bea17915a3$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($9d71eddeeb55bb1f$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($07e8d8991bf446d0$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($75aab771a1ff6795$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($baf3c69a8c8b4f49$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($136a7971b8762c22$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($27e68ee3d559cb40$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($9c047c756214629e$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($8481950dfc0be19d$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($dda6acf3f53f5b33$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($38a246f056627768$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($5c9e276c5bb04d95$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($69adf5dbcefa21d1$exports))),
        (0, (/*@__PURE__*/$parcel$interopDefault($786a5c2a45ce367b$exports)))
    ]
};
function $67531365a2ce8fb7$var$onSecondSliderShow() {
    document.body.style.overflow = "hidden";
    const sections = document.querySelectorAll("section:not(#projects)");
    sections.forEach((section)=>{
        section.style.filter = "blur(10px)";
        section.style.pointerEvents = "none";
        $67531365a2ce8fb7$var$pauseAutoSlide();
        document.addEventListener("click", $67531365a2ce8fb7$var$onClickOutsideSecondSlider);
    });
}
const $67531365a2ce8fb7$var$mainSliderButtons = document.querySelectorAll("#main-slider .slider-button");
$67531365a2ce8fb7$var$mainSliderButtons.forEach((button, index)=>{
    button.addEventListener("click", ()=>{
        const images = $67531365a2ce8fb7$var$imagesForButtons[`button${index + 1}`];
        $67531365a2ce8fb7$var$changeImages(images);
        $67531365a2ce8fb7$var$sliderContainer.style.display = "block";
        console.log("test");
        setTimeout(()=>{
            $67531365a2ce8fb7$var$sliderContainer.scrollIntoView({
                behavior: "smooth"
            });
        }, 500);
        setTimeout(()=>{
            $67531365a2ce8fb7$var$onSecondSliderShow();
        }, 100);
    });
});
const $67531365a2ce8fb7$var$mainImg = document.getElementById("current");
function $67531365a2ce8fb7$var$changeImages(images) {
    const subImgsContainer = document.querySelector("#slider-container .sub-imgs");
    subImgsContainer.innerHTML = "";
    images.forEach((imageSrc, index)=>{
        const imgElement = document.createElement("img");
        imgElement.setAttribute("src", imageSrc);
        imgElement.setAttribute("style", "height: 90px");
        subImgsContainer.appendChild(imgElement);
        if (index === 0) $67531365a2ce8fb7$var$mainImg.setAttribute("src", imageSrc);
    });
    $67531365a2ce8fb7$var$imgs = document.querySelectorAll(".sub-imgs img");
    $67531365a2ce8fb7$var$imgs.forEach((img)=>img.addEventListener("click", $67531365a2ce8fb7$var$imgClick));
}
function $67531365a2ce8fb7$var$onClickOutsideSecondSlider(event) {
    const readMoreButton = document.getElementById("read-more-button");
    if (!$67531365a2ce8fb7$var$sliderContainer.contains(event.target) && event.target !== readMoreButton) $67531365a2ce8fb7$var$onHideSecondSlider();
}
function $67531365a2ce8fb7$var$onHideSecondSlider() {
    document.body.style.overflow = "auto";
    const sections = document.querySelectorAll("section:not(#projects)");
    sections.forEach((section)=>{
        section.style.filter = "none";
        section.style.pointerEvents = "auto";
    });
    $67531365a2ce8fb7$var$sliderContainer.style.display = "none";
    document.getElementById("projects").scrollIntoView({
        behavior: "smooth"
    });
    document.removeEventListener("click", $67531365a2ce8fb7$var$onClickOutsideSecondSlider);
    $67531365a2ce8fb7$var$startAutoSlide();
}


//# sourceMappingURL=index.afcf2f32.js.map
